import { z } from 'zod';
import { sapSystemSchema } from '../sites';

// ! 👇 Maps to S/4HANA CDS views I_FunctionalLocationData / I_FunctionalLocationText (NICE) and the ECC6 equivalent (BEST).
export const functionalLocationSchema = z.object({
  ENVIRONMENT: sapSystemSchema,
  SYSTEM: z.string().max(3), // e.g. R75
  CLIENT: z.string().max(3), // e.g. 210
  FUNCTIONALLOCATION: z.string().min(1).max(30), // TPLNR — external format
  LANGUAGE: z.string().max(1), // SPRAS
  FUNCTIONALLOCATIONNAME: z.string().max(40), // PLTXT
  SUPERIORFUNCTIONALLOCATION: z.string().max(30).optional(), // TPLMA — hierarchy parent, none on a root
  MAINTENANCEPLANNINGPLANT: z.string().max(4), // IWERK
  MAINTOBJECTLOCACCTASSGMTNMBR: z.string().max(12).optional(), // ILOAN — internal id
  MAINTENANCEPLANT: z.string().max(4).optional(), // SWERK
  PLANTSECTION: z.string().max(3).optional(), // BEBER
  // Only set on leaf-level locations in practice — higher structural nodes often have none.
  MAINTENANCEPLANNERGROUP: z.string().max(3).optional(), // INGRP
  FUNCNLLOCISMARKEDFORDELETION: z.boolean().default(false), // LVORM
  ABCINDICATOR: z.string().max(1).optional(), // ABCKZ
  MAINTOBJECTFREEDEFINEDATTRIB: z.string().max(30).optional(), // EQFNR — sort field
  ASSETLOCATION: z.string().max(10).optional(), // STORT
  ASSETROOM: z.string().max(8).optional(), // MSGRP
  WORKCENTER: z.string().max(8).optional(), // ARBPL — external format
});

export type FunctionalLocation = z.infer<typeof functionalLocationSchema>;
